import mori from 'mori';

/**
 * Filter footnotes per cell and flatten them
 * @param  {Array} key                [key array for footnotes]
 * @param  {mori.hashMap} footnotes   [footnotes]
 * @return {Array}                    [footnotes for key]
 */
export default function footnoteCallback(key, footnotes, isTrend = false) {
  if (!isLocationInFootnotes(key, footnotes)) {
    // Location isn't in footnotes
    return [];
  }

  return mori.toJs(mori.distinct(mori.flatten(
    mori.map(
      (row) => mori.flatten(mori.rest(row)),
      mori.filter(
        (note) => {
          // If key[2], then we are coming from cellRenderer and we are on a geoMulti indicator
          // We will match on the entire key - State, Dist., Value
          // We will then attemp to match on just State and Dist.
          if (key[2] && mori.count(mori.first(note)) === 4) {
            return mori.isSubset(
              mori.set(key),
              mori.first(note)
            );
            // No key[2] means we proceed as normal
          } else if (!Array.isArray(key[1])) {
            return mori.isSubset(
              mori.set(key[2] ? key.slice(0, 2) : key),
              mori.first(note)
            );
          }
          return (
            // We need to include only headerGroup, only columnTile, and combined
            mori.isSubset(
              mori.set([
                key[0],
                mori.hashMap(
                  key[1][0],
                  key[1][1]
                ),
              ]),
              mori.first(note)
            ) ||
            mori.isSubset(
              mori.set([key[0], key[1][0]]),
              !isTrend ? mori.first(note) : mori.rest(mori.first(note))
            ) ||
            mori.isSubset(
              mori.set([key[0], key[1][1]]),
              !isTrend ? mori.first(note) : mori.rest(mori.first(note))
            ) || (
              mori.first(mori.first(mori.last(mori.first(note)))) === 'any' &&
              mori.equals(
                mori.set([key[0], key[1][1]]),
                mori.set(
                  [
                    mori.first(mori.rest(mori.first(note))),
                    mori.last(mori.last(mori.last(mori.first(note)))),
                  ]
                ) // set
              ) // equals
            )
          );
        },
        footnotes
      )
    )
  )));
}

/**
 * Check if location is in footnotes
 * @param  {Array} key                [key array for footnotes]
 * @param  {mori.hashMap} footnotes   [footnotes]
 * @return {Boolean}                  [if location is in footnotes]
 */
function isLocationInFootnotes(key, footnotes) {
  return mori.count(mori.filter(
    (item) => item === key[0],
    mori.distinct(mori.reduceKV(
      // accumulator, key, value (value isn't needed here)
      (acc, rKey) => mori.conj(acc, mori.first(mori.rest(rKey))),
      mori.vector(),
      footnotes,
    ))
  )) > 0;
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/getFootnotes/footnoteCallback.js
 **/